import { modules } from "@core/utils/modules.js";

export default [
    {
        path: "attendance",
        name: "operations-attendance",
        redirect: { name: "operations-attendance-report" },
        component: () => import("@/views/operations/operations-attendance/OperationsAttendanceMain.vue"),
        meta: {
            section: 40,
            module: modules.OPERATIONS

        },
        children: [
            {
                path: "report",
                name: "operations-attendance-report",
                component: () =>
                    import(
              /* webpackChunkName: "OperationsAttendanceReportTable" */ "@/views/commons/employee_attendance/AttendanceReportTable.vue"
                    ),
                meta: {
                    section: 40,
                    pageTitle: "Attendance",
                    module: modules.OPERATIONS
                },
            },

        ],
    },
];